import { useEffect, useMemo } from 'react';
import { MdmsReminderBanner, useMdmsPhaseLive } from './MdmsReminderBanner';
import { getIstDateIso } from '../utils/istTime';

export function TeacherStrengthReminder({
  labels,
  submissionStatus,
  isLoading,
  onRefresh,
  selectedDate,
}) {
  const phase = useMdmsPhaseLive();
  const todayIso = useMemo(() => getIstDateIso(), []);

  useEffect(() => {
    if (selectedDate && selectedDate.slice(0, 10) === todayIso) {
      onRefresh?.();
    }
  }, [selectedDate, todayIso]); // eslint-disable-line react-hooks/exhaustive-deps

  const viewingToday = selectedDate && String(selectedDate).slice(0, 10) === todayIso;
  if (!viewingToday || phase === 'none' || isLoading) return null;

  const pending = (submissionStatus?.classes || []).filter((c) => !c.submitted);
  if (pending.length === 0) return null;

  const names = pending.map((c) => c.division_name).join(', ');
  const message =
    phase === 'final'
      ? pending.length === 1
        ? labels.teacherMdmsFinalOne.replace('{division}', pending[0].division_name)
        : labels.teacherMdmsFinalMany.replace('{classes}', names)
      : pending.length === 1
        ? labels.teacherMdmsWarningOne.replace('{division}', pending[0].division_name)
        : labels.teacherMdmsWarningMany.replace('{count}', String(pending.length));

  return <MdmsReminderBanner phase={phase} message={message} />;
}
